import styled from "styled-components";

export const SessionTitle = styled.h4`
  margin: 20px 0 2px;
  text-align: left;
`;